import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shadcn/components/ui/Select';
/**
 * Dropdown for selecting a pack group.
 *
 * @param {Object} props - The component props
 * @param {boolean} props.disabled - Whether the input is disabled
 * @param {Object[]} props.packGroups - Array of pack group objects to choose from
 * @param {Object} props.selectedPackGroupID - Currently selected pack group id
 * @param {Function} props.setSelectedPackGroupID - Callback function to update the selected pack group id
 * @returns {JSX.Element} A dropdown menu component for pack group selection
 */
function PackGroupInput({ disabled, packGroups, selectedPackGroupID, setSelectedPackGroupID }) {
    return (
        <Select disabled={!packGroups} onValueChange={setSelectedPackGroupID} value={selectedPackGroupID}>
            <SelectTrigger className="grow" disabled={disabled}>
                <div className="space-x-2">
                    <span className="font-medium">Pack Group</span>
                    {selectedPackGroupID ? (
                        <SelectValue placeholder="None" />
                    ) : (
                        <span className="text-muted-foreground">None</span>
                    )}
                </div>
            </SelectTrigger>
            <SelectContent>
                {packGroups?.length === 0 && (
                    <SelectItem disabled value="none">
                        None
                    </SelectItem>
                )}
                {packGroups?.map((packGroup) => (
                    <SelectItem key={packGroup.id} value={packGroup.id}>
                        {packGroup.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

export default PackGroupInput;
